/**
 * Composant de routage pour le profil
 * Redirige vers la bonne page de profil selon le role de l'utilisateur
 * - Acheteurs -> Profil (ancien)
 * - Prestataires (Libre ou Accord Cadre) -> ProfilUnifie
 */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Profil from './Profil';
import ProfilUnifie from './ProfilUnifie';

/**
 * Roles Acheteur
 */
const ACHETEUR_ROLES = [
  'acheteur',
  'acheteur signataire',
  'acheteur signataire admin',
];

/**
 * Determine si l'utilisateur est un acheteur
 */
const isAcheteurRole = (role: string | undefined): boolean => {
  if (!role) return false;
  const lowerRole = role.toLowerCase();
  return ACHETEUR_ROLES.some(r => lowerRole.includes(r.toLowerCase()));
};

/**
 * Composant de routage
 */
const ProfilRouter: React.FC = () => {
  const { user } = useAuth();
  
  // Si l'utilisateur est un acheteur, utiliser l'ancien Profil
  if (isAcheteurRole(user?.role)) {
    return <Profil />;
  }
  
  // Sinon, utiliser le Profil unifie (Prestataires Libres et Accord Cadre)
  return <ProfilUnifie />;
};

export default ProfilRouter;
